import axios, { config } from '..';
import { UPDATE_SET_SUCCESS, UPDATE_SET_FAILED } from '../../actionTypes';

export default (id, body) => async (dispatch) => {
  try {
    const response = await axios.patch(
      `/providers/sets/${id}/update`,
      body,
      config
    );

    const {
      data: { message, data },
    } = response;
    dispatch({
      type: UPDATE_SET_SUCCESS,
      message,
      results: data,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    dispatch({ type: UPDATE_SET_FAILED, error });
  }
};
